import { render, staticRenderFns } from "./material-center.vue?vue&type=template&id=4b59e6ca&scoped=true&"
import script from "./material-center.vue?vue&type=script&lang=js&"
export * from "./material-center.vue?vue&type=script&lang=js&"
import style0 from "./material-center.vue?vue&type=style&index=0&id=4b59e6ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b59e6ca",
  null
  
)

export default component.exports